
export const COMPANY_CODE_SUNSHINE_SMILE_GERMANY = '0200'

export const COMPANY_CODE_SUNSHINE_SMILE_UK = '1066'


export const COMPANY_CODE_DISPLAY_NAMES = {
    [COMPANY_CODE_SUNSHINE_SMILE_GERMANY]: 'Sunshine Smile GmbH',
    [COMPANY_CODE_SUNSHINE_SMILE_UK]: 'SSS UK Services Limited',
}

export const COMPANY_CODE_SELECT_VALUE_LIST = Object.keys(COMPANY_CODE_DISPLAY_NAMES).map((key) => ({
    id: key,
    value: COMPANY_CODE_DISPLAY_NAMES[key],
}))

export const LANGUAGE_LIST = [
    {
        id: '',
        value: '',
    },
    {
        id: 'de_DE',
        value: 'German (Germany)',
    },
    {
        id: 'de_AT',
        value: 'German (Austria)',
    },
    {
        id: 'de_CH',
        value: 'German (Switzerland)',
    },
    {
        id: 'en_GB',
        value: 'English (Great Britain)',
    },
    {
        id: 'es_ES',
        value: 'Spanish',
    },
    {
        id: 'fr_FR',
        value: 'French (France)',
    },
    {
        id: 'fr_BE',
        value: 'French (Belgium)',
    },
    {
        id: 'nl_NL',
        value: 'Dutch (Netherlands)',
    },
    {
        id: 'nl_BE',
        value: 'Dutch (Belgium)',
    },
    {
        id: 'sv_SE',
        value: 'Swedish',
    },
    {
        id: 'it_IT',
        value: 'Italian',
    },
    {
        id: 'da_DK',
        value: 'Danish',
    },
]

export const COUNTRY_CODE = {
    AT: 'AT',
    CH: 'CH',
    DE: 'DE',
    ES: 'ES',
    GB: 'GB',
    FR: 'FR',
    NL: 'NL',
    SE: 'SE',
    BE: 'BE',
    IT: 'IT',
    DK: 'DK',
}

export const COUNTRY_CODE_LIST = [
    {
        id: COUNTRY_CODE.DE,
        value: 'Germany',
    },
    {
        id: COUNTRY_CODE.AT,
        value: 'Austria',
    },
    {
        id: COUNTRY_CODE.CH,
        value: 'Switzerland',
    },
    {
        id: COUNTRY_CODE.GB,
        value: 'United Kingdom',
    },
    {
        id: COUNTRY_CODE.ES,
        value: 'Spain',
    },
    {
        id: COUNTRY_CODE.FR,
        value: 'France',
    },
    {
        id: COUNTRY_CODE.NL,
        value: 'Netherlands',
    },
    {
        id: COUNTRY_CODE.SE,
        value: 'Sweden',
    },
    {
        id: COUNTRY_CODE.BE,
        value: 'Belgium',
    },
    {
        id: COUNTRY_CODE.IT,
        value: 'Italy',
    },
    {
        id: COUNTRY_CODE.DK,
        value: 'Denmark',
    },
]

export const WEBSITE_URL_LIST = [
    {
        id: COUNTRY_CODE.DE,
        value: 'https://plusdental.de',
    },
    {
        id: COUNTRY_CODE.AT,
        value: 'https://plusdental.at',
    },
    {
        id: COUNTRY_CODE.CH,
        value: 'https://plusdental.ch',
    },
    {
        id: COUNTRY_CODE.GB,
        value: 'https://plusdent.co.uk',
    },
    {
        id: COUNTRY_CODE.ES,
        value: 'https://plus-dental.es',
    },
    {
        id: COUNTRY_CODE.FR,
        value: 'https://plusdental.fr',
    },
    {
        id: COUNTRY_CODE.NL,
        value: 'https://plus-dental.nl',
    },
    {
        id: COUNTRY_CODE.SE,
        value: 'https://plusdental.se',
    },
]



// WEBPACK FOOTER //
// ./src/modules/internationalization/const.js